<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-cursos-capacitacion />
    <ver-documento />
    <h3 class="primary--text">
      <v-icon color="primary">edit</v-icon> Cursos de capacitación
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarCursosCapacitacion({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Cursos capacitacion</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->

            <td class="text-xs-center">
              {{ items.item.curso ? items.item.curso : "" }}
            </td>
            <td class="text-xs-center">
              {{
                items.item.institucion
                  ? items.item.institucion.nombre_institucion
                  : ""
              }}
            </td>
            <td class="text-xs-center">{{ items.item.duracion_horas }}</td>
            <td class="text-xs-center">{{ items.item.anio }}</td>
            <td class="text-xs-center">
              {{ items.item.url_documento != null ? "SI" : "NO" }}
            </td>

            <td class="text-xs-center">
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="crearActualizarCursosCapacitacion(items.item)"
                  color="primary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  color="green"
                  dark
                  icon
                  slot="activator"
                  @click.native="verDocumento(items.item)"
                >
                  <v-icon color="dark">visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  color="red"
                  dark
                  icon
                  slot="activator"
                  @click="deleteItem(items.item.id, 'cursoCapacitacion')"
                >
                  <v-icon color="dark">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarCursosCapacitacion from "../dialogs/CrearActualizarCursoCapacitacion"; // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue";

export default {
  props: ["persona"],
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  components: [VerDocumento],
  // Variables iniciales del componente
  data() {
    return {
      url: "cursoCapacitacions",
      graphql: true,

      // Cabecera de la tabla
      headers: [
        {
          text: "Denominación del Curso",
          value: "curso",
          align: "center"
        },
        {
          text: "Institución Académica",
          value: "id_institucion",
          align: "center"
        },
        { text: "Duración en Horas", value: "duracion_horas", align: "center" },
        { text: "Año", value: "anio", align: "center" },

        {
          text: "Documento Adjunto",
          value: "url_documento",
          align: "center"
        },

        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
       id
      duracion_horas
      anio
      id_parametro_nivel
      id_estado
      id_persona
      curso
      id_institucion
      id_parametro_tipo_certificado
      calificacion
      url_documento
      
      institucion{
        id
        nombre_institucion
      }

      `,
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id
        }
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // this.obtenerInstitucion();
    this.$bus.$on("verDocumento", item => {
      this.url = item;
      this.dialog = true;
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    crearActualizarCursosCapacitacion(item) {
      this.$bus.$emit("openDialogCrearActualizarCursosCapacitacion", item);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $curso_capacitacion: EditCursoCapacitacion!) {
              cursoCapacitacionEdit(id: $id, curso_capacitacion: $curso_capacitacion) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            curso_capacitacion: data
          }
        });

        if (value === 1) {
          this.$message.success("Cursos Capacitacion habilitado");
        } else {
          this.$message.warning("Cursos Capacitacion deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
       this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarCursosCapacitacion,
    VerDocumento
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/CursosCapacitacion.vue